import React from 'react';
import { Row, Col } from 'reactstrap';
import { Input } from '../../lib/form-field';

const FormTemplateInfo = () => (
  <Row>
    <Col md="12">
      <Input type="text" name="name" id="name" label="Template Name" required />
    </Col>
    <Col md="12">
      <Input
        type="textarea"
        name="description"
        id="description"
        label="Description"
        rows={2}
      />
    </Col>
  </Row>
);

export default FormTemplateInfo;
